import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import EmbeddedDashboardGeneralErrorLayoutComponent from './components/layout/index';
import {IEmbeddedDashboardGeneralErrorStore} from './embedded-dashboard-general-error.stores';

interface EmbeddedDashboardGeneralErrorViewProps {
    embeddedDashboardGeneralErrorStore: IEmbeddedDashboardGeneralErrorStore;
}

@observer
export class EmbeddedDashboardGeneralErrorViewComponent extends TechseeBaseComponent<EmbeddedDashboardGeneralErrorViewProps> {
    renderInternal(): JSX.Element {
        const translate = this.props.embeddedDashboardGeneralErrorStore.localizationService.translate.bind(
            this.props.embeddedDashboardGeneralErrorStore.localizationService
        );
        return <EmbeddedDashboardGeneralErrorLayoutComponent translate={translate} />;
    }
}

export const EmbeddedDashboardGeneralErrorView = inject('embeddedDashboardGeneralErrorStore')(
    EmbeddedDashboardGeneralErrorViewComponent
) as IReactComponent;
